import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { VStack as s, HStack as l } from "@chakra-ui/react";
import { Typography as m } from "../../dataDisplay/Typography/Typography.mjs";
import { PasswordRequirementStatusIcon as n } from "./PasswordRequirementStatusIcon.mjs";
import "react";
import { addPeriodToString as d } from "../../../utils/addPeriodToString.mjs";
import "react-nanny";
import { getRequirementAriaLabel as p } from "./passwordInputFunctions.mjs";
const h = ({ id: t, requirements: a }) => /* @__PURE__ */ o(s, { spacing: 1, align: "stretch", color: "gray.800", role: "list", children: [
  /* @__PURE__ */ e(m, { textStyle: "bodySmall", children: "Password must:" }),
  a.map((r, i) => /* @__PURE__ */ o(
    l,
    {
      spacing: 2,
      "aria-label": `${d(p(r))}`,
      role: "listitem",
      children: [
        /* @__PURE__ */ e(
          n,
          {
            status: r.status,
            "aria-describedby": `${t}-requirement-${i}`
          }
        ),
        /* @__PURE__ */ e(m, { textStyle: "bodySmall", id: `${t}-requirement-${i}`, children: r.requirement })
      ]
    },
    r.requirement
  ))
] });
export {
  h as PasswordRequirements
};
